export enum ProtokollCurrentStatusType {
    Pending = -1,
    Starting,
    Running,
    Finished,
    Failed,
}

export enum ProtokollStatusType {
    Information,
    Success,
    Error
}

export enum ProtokollAufgabeType {
    NA,
    StammdatenImport,
    SerienImport,
    MappingImport,
    XMLRechnungsimport,
    CsvXmlReporter,
    ServiceportalSchnittstelle,
    DatenschutzSchritt,
    IHSHintegrundprozesse,
    SyncDmsValues,
    ImmosolveEverrealImport,
    XMLMeldungsImport,
    PostBuchungsprozessImport,
    VblExport,
    FolderChecker,
    Sollstellung,
    SyncDKB,
    EnTabWohnungsuebergabe,
    ReTermin,
    ReAsyncStartProc,
    Schedulertestlauf,
    MarkOldData,
    EBanking,
    ZahlungsverkehrPersonen,
    Berichtspaket,
    Verbraucherpreisindex,
    Buchungsimport,
    SftpTransfer,
    TrinityExport,
    BisonBoxExport,
    BkBerechnungslauf,
    DynTabImport,
    MSOfficeCheckJob,
    Serialisierer,
    Zahlungstoleranz,
    Verwaltungsabrechnung,
    MahnlaufVorschlagie,
    MahnlaufAnmahnen,
    HkdWebserviceOnSiteRoles,
    WKZBuchungsLauf,
    Lizenzverbrauch,
    LizenzverbrauchFremdverwalter,
    SaldovortraegeSachkonten,
    SaldovortraegePerkonten,
    DATEVExport,
    BKUnterjaerig,
    Verwaltergebuehren,
    Kautionsmahnschreiben,
    EIBEPortal,
    Datensatzgenerator,
    IndexBerechnung,
    eProcessIeadmingroupsreport,
    eProcessIeallfagrafik,
    eProcessIebtkreisreport,
    eProcessIebuexporttool,
    eProcessIebvgimp,
    eProcessIecore2cor1,
    eProcessIecrebuc,
    eProcessIedatev,
    eProcessIediamantbuexp,
    eProcessIedmssyncins,
    eProcessIeez2mandat,
    eProcessIefhkde,
    eProcessIefirst,
    eProcessIeflerlmplanmiete,
    eProcessIegavstarttool,
    eProcessIehansainvestbuexp,
    eProcessIeintrealsapbuexp,
    eProcessIekredebtool,
    eProcessIemarkolddata,
    eProcessIemvtxt2obj,
    eProcessIeobject,
    eProcessIeobjektende,
    eProcessIeplusservices,
    eProcessIerevcexport,
    eProcessIesepagenref,
    eProcessIesepanotification,
    eProcessIesevumstellung,
    eProcessIestdbuexport,
    eProcessIeumbruecklage,
    eProcessIeupdsrvc,
    eProcessIeuserexpimp,
    eProcessIevblexport,
    eProcessIevirtktotool,
    eProcessIexmlmeldungsimport,
    eProcessIeyardibuexp,
    eProcessIezensusimport,
    eProcessIe1010,
    eProcessIe1022,
    eProcessIe1033,
    eProcessIe1060,
    eProcessIe1071,
    eProcessIe1072,
    eProcessIe107211,
    eProcessIe1073,
    eProcessIe1079,
    eProcessIe11051,
    eProcessIe117401,
    eProcessIe129301,
    eProcessIe1300,
    eProcessIe1302,
    eProcessIe1303,
    eProcessIe1420,
    eProcessIe1603kista,
    eProcessIe2000hndl,
    eProcessIe2000postbu,
    eProcessIe2000prj,
    eProcessIe200010bu,
    eProcessIe200082,
    eProcessIe200083,
    eProcessIe200084,
    eProcessIe200085,
    eProcessIe2010,
    eProcessIe2011,
    eProcessIe2013,
    eProcessIe2014,
    eProcessIe2022,
    eProcessIe20311,
    eProcessIe2039,
    eProcessIe204001,
    eProcessIe204002,
    eProcessIe2048,
    eProcessIe204801,
    eProcessIe2060,
    eProcessIe2061,
    eProcessIe2063,
    eProcessIe2080,
    eProcessIe2115,
    eProcessIe2150,
    eProcessIe2151,
    eProcessIe2455,
    eProcessIe2600,
    eProcessIe2900,
    eProcessIe3010,
    eProcessIe3025,
    eProcessIe3026,
    eProcessIe3028,
    eProcessIe30351,
    eProcessIe3041,
    eProcessIe3050,
    eProcessIe3057,
    eProcessIe3057w,
    eProcessIe305715,
    eProcessIe30572,
    eProcessIe3058,
    eProcessIe30581,
    eProcessIe3083,
    eProcessIe3090,
    eProcessIe4040,
    eProcessIe405001,
    eProcessIe405002,
    eProcessIe405003,
    eProcessIe4051,
    eProcessIe4075,
    eProcessIe4078,
    eProcessIe409001,
    eProcessIe6020,
    eProcessIe6040,
    eProcessIe7100,
    eProcessIe800021,
    eProcessIe800025,
    eProcessIe8009,
    eProcessIe900010,
    eListeLeadm90,
    eListeLeadm91,
    eListeLeadm92,
    eListeLeadm93,
    eListeLedatev01,
    eListeLedatev02,
    eListeLedatev03,
    eListeLe1001,
    eListeLe1002,
    eListeLe1003,
    eListeLe1005,
    eListeLe1006,
    eListeLe101002,
    eListeLe101003,
    eListeLe102001,
    eListeLe102002,
    eListeLe102003,
    eListeLe1021,
    eListeLe103002,
    eListeLe1040,
    eListeLe1047,
    eListeLe1060,
    eListeLe1061,
    eListeLe107001,
    eListeLe107019,
    eListeLe107049,
    eListeLe107050,
    eListeLe107055,
    eListeLe107101,
    eListeLe107102,
    eListeLe107103,
    eListeLe107104,
    eListeLe1071041,
    eListeLe107105,
    eListeLe107106,
    eListeLe107107,
    eListeLe107108,
    eListeLe107109,
    eListeLe107110,
    eListeLe107111,
    eListeLe107112,
    eListeLe107113,
    eListeLe107115,
    eListeLe107120,
    eListeLe107122,
    eListeLe107123,
    eListeLe107128,
    eListeLe107129,
    eListeLe107135,
    eListeLe107232,
    eListeLe1082,
    eListeLe1090,
    eListeLe109041,
    eListeLe11722,
    eListeLe11723,
    eListeLe117235,
    eListeLe11725,
    eListeLe11728,
    eListeLe11729,
    eListeLe11730,
    eListeLe1230051,
    eListeLe1230052,
    eListeLe123010,
    eListeLe130c09,
    eListeLe2000081,
    eListeLe200010,
    eListeLe2001,
    eListeLe200101,
    eListeLe200105,
    eListeLe200109,
    eListeLe200119,
    eListeLe200120,
    eListeLe200140,
    eListeLe2003,
    eListeLe200301,
    eListeLe2004,
    eListeLe2005,
    eListeLe2006,
    eListeLe201004,
    eListeLe201051,
    eListeLe201052,
    eListeLe201053,
    eListeLe201054,
    eListeLe2014,
    eListeLe2016,
    eListeLe2025,
    eListeLe2031,
    eListeLe2035,
    eListeLe204004,
    eListeLe204005,
    eListeLe204006,
    eListeLe204007,
    eListeLe20401,
    eListeLe204031,
    eListeLe204032,
    eListeLe204034,
    eListeLe204401,
    eListeLe204402,
    eListeLe204403,
    eListeLe2049,
    eListeLe2051,
    eListeLe2052,
    eListeLe2053,
    eListeLe206202,
    eListeLe2072,
    eListeLe2073,
    eListeLe2074,
    eListeLe2075,
    eListeLe2076,
    eListeLe211101,
    eListeLe2113,
    eListeLe21131,
    eListeLe2119,
    eListeLe2123,
    eListeLe2124,
    eListeLe215010,
    eListeLe22001,
    eListeLe22002,
    eListeLe2300,
    eListeLe2400,
    eListeLe240001,
    eListeLe240002,
    eListeLe240007,
    eListeLe24002,
    eListeLe2450,
    eListeLe304002,
    eListeLe304003,
    eListeLe304004,
    eListeLe304005,
    eListeLe304006,
    eListeLe304007,
    eListeLe304011,
    eListeLe304012,
    eListeLe30571,
    eListeLe30572,
    eListeLe30581,
    eListeLe30591,
    eListeLe307601,
    eListeLe40151,
    eListeLe40152,
    eListeLe40153,
    eListeLe404002,
    eListeLe404011,
    eListeLe404051,
    eListeLe404051excel,
    eListeLe404052,
    eListeLe404053,
    eListeLe40600,
    eListeLe40604,
    eListeLe40606,
    eListeLe40611,
    eListeLe4081,
    eListeLe4082,
    eListeLe4085,
    eListeLe6001,
    eListeLe60305,
    eListeLe8009,
    eListeLx107004,
    eListeLe206203,
    eListeLe240003,
}

export enum ProtokollAufgabeRegelActionType {
    SaveProtocol,
    SendEmail,
}